/**
 * Meetings store
 */
import { create } from 'zustand';
const defaultFilters = {
    limit: 20,
    offset: 0,
};
export const useMeetingsStore = create((set, get) => ({
    meetings: [],
    currentMeeting: null,
    total: 0,
    hasMore: false,
    filters: defaultFilters,
    isLoading: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    error: null,
    setMeetings: (meetings, total, hasMore) => {
        set({
            meetings,
            total: total ?? meetings.length,
            hasMore: hasMore ?? false,
        });
    },
    addMeeting: (meeting) => {
        set((state) => ({
            meetings: [meeting, ...state.meetings],
            total: state.total + 1,
        }));
    },
    updateMeeting: (meetingId, updates) => {
        set((state) => ({
            meetings: state.meetings.map((m) => m.id === meetingId ? { ...m, ...updates } : m),
            currentMeeting: state.currentMeeting?.id === meetingId
                ? { ...state.currentMeeting, ...updates }
                : state.currentMeeting,
        }));
    },
    removeMeeting: (meetingId) => {
        set((state) => ({
            meetings: state.meetings.filter((m) => m.id !== meetingId),
            total: Math.max(0, state.total - 1),
            currentMeeting: state.currentMeeting?.id === meetingId ? null : state.currentMeeting,
        }));
    },
    setCurrentMeeting: (meeting) => {
        set({ currentMeeting: meeting });
    },
    setFilters: (filters) => {
        set((state) => ({
            filters: { ...state.filters, ...filters },
        }));
    },
    resetFilters: () => {
        set({ filters: defaultFilters });
    },
    setLoading: (isLoading) => {
        set({ isLoading });
    },
    setCreating: (isCreating) => {
        set({ isCreating });
    },
    setUpdating: (isUpdating) => {
        set({ isUpdating });
    },
    setDeleting: (isDeleting) => {
        set({ isDeleting });
    },
    setError: (error) => {
        set({ error });
    },
    clearError: () => {
        set({ error: null });
    },
}));
//# sourceMappingURL=meetings.js.map